import { createBrowserRouter } from "react-router-dom";
import Layout from "../../Layouts";
import Basic404 from "../Pages/Error/Basic404";
import Login from "../Pages/Auth/Login";
import {ProtectedRoute, RouteAuth } from "../../Helpers/PermissionHandler";
import AssessmentForm from "../Pages/AssessmentForm/";
import Dashboard from "../Pages/Dashboard";
import InspectionStage from "../Pages/InspectionStage";
import InspectionLogBookManager from "../Pages/InspectionLogBookManager";
import InvoiceList from "../Pages/Invoices/InvoiceList";
import CreateInvoice from "../Pages/Invoices/CreateInvoice";
import PaymentList from "../Pages/Payments/PaymentList";
import VehicleRoutes from "../Pages/ReportTool/VehicleRoutes";


const RoutesMaster = (isAuthenticated,userData)=>{
    return createBrowserRouter([
        {
            path:'/',
            // element:isAuthenticated? <Layout pathto='assessment'/>:<Login/>,
            element:isAuthenticated? <RouteAuth LoggedUserProfile={userData}/>:<Login/>,
            errorElement:<Basic404/>,
            children:[
                {
                    path:'/login',
                    element:<Login/>
                },{
                    path:'/logout',
                    element:<Login/>,
                }    

            ]
        },{
            path:'/vehicle-inspection',
            element:<Layout/>,
            children:[
                {
                    path:'stage',
                    element:<InspectionStage/>
                },{
                    path:'form',
                    element:<AssessmentForm/>
                },{
                    path:'checklist-manager',
                    element:<InspectionLogBookManager/>
                }
            ]
        },{
            path:'/dashboard',
            element:<Layout/>,
            children:[
                {
                    path:'/dashboard',
                    element:<Dashboard/>
                }
            ]
        },{
            path:'/invoices',
            element:<Layout/>,
            children:[
                {
                    path:'vehicle-list',
                    element:<InvoiceList serviceType={11}/>
                },{
                    path:'firearm-list',
                    element:<InvoiceList serviceType={1}/>
                },{
                    path:'payment',
                    element:<PaymentList/>
                },{
                    path:'create',
                    element:<CreateInvoice/>
                }
            ]
        },{
            path:'/reports',
            element:<Layout/>,
            children:[
                {
                    path:'vehicle-routes',
                    element:<VehicleRoutes/>
                }
            ]
        }
    ])
}


export default RoutesMaster;